import loading from './index.vue'
export default {
    install(Vue,opt) {
        // console.log(this,'vvvv');
        const loadingMark = Vue.extend(loading)
        // console.dir(loadingMark, 'loadingMark');
        this.domLoadList=[]
        var _this=this
        function $loading(param) {
            // console.log(param,'pppppppp')
            let nowLoading = new loadingMark()
            // console.log(nowLoading.item,'$loading');
            // nowLoading.item=param.item || ''
            nowLoading.$mount()
            // console.log(nowLoading.$el,'$mount');
            _this.domLoadList.push(nowLoading.$el)
            //插入dom元素
            document.querySelector(opt.container).appendChild(nowLoading.$el)
            $loading.end=function(p){
                // console.log(this,'end');
                if(_this.domLoadList[0]){
                    document.querySelector(opt.container).removeChild(_this.domLoadList[0])
                    _this.domLoadList.splice(0,1)
                }
                
            }
        }
        Vue.loading = Vue.prototype.$loading = $loading
    }
}



// WEBPACK FOOTER //
// ./src/components/v_loading/index.js